require('./myProfileDocumentationContractsView.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const Immutable = require('immutable');
// @ actions
const depositsActions = require('actions/deposits');
const cardsInformation = require('actions/cardInformation');
const onboardDocument = require('actions/onboardDocument');
const cardsCanceled = require('actions/cardsCanceled');
const okApiDocumentsActions = require('actions/okApiDocuments');

// @ commons
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
const { LabelFilterRange } = require('commonsComponents/labelFilterRange');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { EmptyState } = require('commonsComponents/emptyState');
// @ components
const ContractSection = require('components/myProfile/myProfileDocumentationContracts/contractSectionView/contractSectionView');
const { FilterContracts } = require('components/myProfile/myProfileDocumentationContracts/filterContractsView/filterContractsView');
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');
const { Accordion } = require('commonsComponents/accordion');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const DocumentsTable = require('components/myProfile/documentsTable/documentsTable');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ helpers
const { isMortgage } = require('utilities/APIParsingHelper');
// @ constants
const infoIcon = require('assets/images/icon-info-blue.svg'); //@hardcoded: replace Icon placeholder

class MyProfileDocumentationContractsView extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showFilters: false,
            interventionSelected: -1,
            interventionValue: '',
            interventions: []
        }

        this.handleClearFilters = this.handleClearFilters.bind(this);
        this.handleToggleShowFilters = this.handleToggleShowFilters.bind(this);
        this.handleFilterIntervention = this.handleFilterIntervention.bind(this);
        this.callbackDownloadFile = this.callbackDownloadFile.bind(this);
        this.downloadById = this.downloadById.bind(this);

    }

    componentDidMount() {
        this.props.getCardsCanceled();
        this.props.requestDeposits();
        this.props.getCardsInformation();
        this.props.getOnboardDocumentDate(this.getIBANFromOldestDateAccount(), this.getExpedienteFromOldestDateAccount());
    }

    getExpedienteFromOldestDateAccount = () => this.props.immProfile.get('numeroExpediente');

    getIBANFromOldestDateAccount() {
        const { immAccounts, immProfile } = this.props;
        const isNerudaUser = immProfile.get('isNerudaUser');
        const numExpendiente = this.getExpedienteFromOldestDateAccount();
        if (isNerudaUser && numExpendiente) {
            return numExpendiente;
        } else {
            let oldestDateAccount = immAccounts.getIn(['byId', immAccounts.getIn(['byOrder', 0])]);
            immAccounts.get('byId').filter((immAccount) => {
                if (Date.parse(oldestDateAccount.get('openingDate')) > Date.parse(immAccount.get('openingDate'))) {
                    oldestDateAccount = immAccount;
                }
            });
            return !!oldestDateAccount && oldestDateAccount.get('iban');
        }
    }

    downloadById (documentId) {
        this.props.getDocumentsOkApiById(documentId)
      }

    getInterventions() {
        const {
            immAccounts,
            immCards,
            immCardsCanceled,
            immLoans,
            immSavings,
            immWallets
        } = this.props;
        let interventions = [];
        let accountInterventions = [];
        let cardsInterventions = [];
        let cardsCanceledInterventions = [];
        let walletInterventions = [];
        let loansInterventions = [];
        let mortgagesInterventions = [];
        let savingsInterventions = [];

        if (immAccounts.size) {
            accountInterventions = immAccounts.get('byOrder').map(indexAccount => {
                return immAccounts.getIn(['byId', indexAccount, 'interventionType']).trim();
            }).toSet();

            cardsInterventions = immCards.get('byOrder').map(indexCard => {
                return immCards.getIn(['byId', indexCard, 'interventionType']).trim();
            }).toSet();

            cardsCanceledInterventions = immCardsCanceled.get('byOrder').map(indexCard => {
                return immCardsCanceled.getIn(['byId', indexCard, 'interventionType']).trim();
            }).toSet();

            walletInterventions = immWallets.map(immWallet => {
                return immWallet.get('intervenerType').trim();
            }).toSet();

            loansInterventions = immLoans.get('byId').filter(
                loan => !isMortgage(loan.get('newProduct'), loan.get('productSubType'), loan.get('productStandard'))).map(immLoan => {
                    return immLoan.get('interventionType').trim();
                }).toSet();

            mortgagesInterventions = immLoans.get('byId').filter(
                loan => !isMortgage(loan.get('newProduct'), loan.get('productSubType'), loan.get('productStandard'))).map(immMortgages => {
                    return immMortgages.get('interventionType').trim();
                }).toSet();

            savingsInterventions = immSavings.map(immSaving => {
                return immSaving.get('interventionType').trim();
            }).toSet();
        }

        interventions = accountInterventions
            .concat(cardsInterventions)
            .concat(cardsCanceledInterventions)
            .concat(walletInterventions)
            .concat(loansInterventions)
            .concat(mortgagesInterventions)
            .concat(savingsInterventions);

        return interventions;
    }

    buildAccordion(date, onboardDocumentOkApi) {
        const errorMessage = formatText('profileContracts-documentDownloadError');
        const {documentId} = onboardDocumentOkApi.toJS()
        const documentList = this.buildDocumentList(date, onboardDocumentOkApi);
        const documentatDownloadAccordionHeader = formatText('profileContracts-accordionHeader');
       const isFetchingDocOkApi = this.props.onboardDocument.get('isFetchingDocOkApi')
      const isFetchingDate =  this.props.onboardDocument.get('isFetchingDate')
        
        let component;
        if (isFetchingDocOkApi || isFetchingDate) {
            component = <LoadingSection />;
        } else if (this.props.onboardDocument.get('fileDownloadError')) {
            component = (
                <section className="contracts-view__onboarding-document-section">
                    {this.buildErrorState(errorMessage)}
                </section>
            );
        } else if (date || documentId) {
            component = (
                <section className="contracts-view__onboarding-document-section">
                    <Accordion isExpanded={true} customClassName="contracts-view__onboarding-document-section--accordion">
                        <AccordionHeader name="AccordionHeader">
                            <div className="contracts-view__onboarding-document-section--accordion-header">
                                <h4 className="contracts-view__onboarding-document-section--accordion-title">
                                    {documentatDownloadAccordionHeader}
                                </h4>
                            </div>
                        </AccordionHeader>
                        <AccordionBody name="AccordionBody">
                            <div className="contracts-view__onboarding-document-section--accordion-body">
                                {documentList}
                            </div>
                        </AccordionBody>
                    </Accordion>
                </section>
            );
        }
        return component;
    }

    getAllCards() {
        const { immCards, immCardsCanceled } = this.props;
        return immCardsCanceled.get('byId').concat(immCards.get('byId'));
    }

    buildContracts() {
        const { immAccounts, immWallets, immLoans, immSavings } = this.props;
        let response = [];
        let accountData = this.filterData(immAccounts.get('byId'), ['interventionType']);
        let cardsData = this.filterData(this.getAllCards(), ['interventionType']);
        let walletsData = this.filterData(immWallets, ['intervenerType']);
        let loansData = this.filterData(immLoans.get('byId').filter(
            loan => !isMortgage(loan.get('newProduct'), loan.get('productSubType'), loan.get('productStandard'))), ['interventionType']);
        let mortgagesData = this.filterData(this.props.immLoans.get('byId').filter(
            loan => isMortgage(loan.get('newProduct'), loan.get('productSubType'), loan.get('productStandard'))), ['interventionType']);
        let savingsData = this.filterData(immSavings, ['interventionType']);
        const preGrantedCredits = (accountData.filter(account =>
            account.getIn(['balances', 'pregrantedCredit', 'amount']) > 0));

        if (accountData.size) {
            response.push(<ContractSection
                key={0}
                title={`${formatText('profileDocumentation-accountTitle')} (${accountData.size})`}
                type="accounts"
                immData={accountData}
                interventionSelected={this.state.interventionValue}
            />);
        }

        if (cardsData.size) {
            response.push(<ContractSection
                key={1}
                title={`${formatText('profileDocumentation-cardsTitle')} (${cardsData.size})`}
                type="credit-card"
                immData={cardsData}
                interventionSelected={this.state.interventionValue}
            />);
        }

        if (walletsData.size) {
            response.push(<ContractSection
                key={2}
                title={`${formatText('profileDocumentation-walletTitle')} (${walletsData.size})`}
                type="wallets"
                immData={walletsData}
                interventionSelected={this.state.interventionValue}
            />);
        }

        if (loansData.size) {
            response.push(<ContractSection
                key={4}
                title={`${formatText('profileDocumentation-loansTitle')} (${loansData.size})`}
                type="loans"
                immData={loansData}
                interventionSelected={this.state.interventionValue}
            />);
        }

        if (mortgagesData.size) {
            response.push(<ContractSection
                key={5}
                title={`${formatText('profileDocumentation-mortgagesTitle')} (${mortgagesData.size})`}
                type="mortgages"
                immData={mortgagesData}
                interventionSelected={this.state.interventionValue}
            />);
        }

        if (savingsData.size) {
            response.push(<ContractSection
                key={6}
                title={`${formatText('profileDocumentation-savingsTitle')} (${savingsData.size})`}
                type="savings"
                immData={savingsData}
                interventionSelected={this.state.interventionValue}
            />);
        }

        if (preGrantedCredits.size) {
            response.push(<ContractSection
                key={7}
                title={`${formatText('profileDocumentation-pregrantedcreditTitle')} (${preGrantedCredits.size})`}
                type="credits"
                immData={preGrantedCredits}
                interventionSelected={this.state.interventionValue}
            />);
        }

        return <div>{response}</div>;
    }

    buildDocumentList(date, onboardDocumentOkApi) {
        const documentType = formatText('profileContracts-accordionHeader');
        const data = [
            {
                'file': {},
                "nombreTipoComunicacion": documentType,
                "nombreGrupoComunicacion": documentType,
                "fechaAlta": date,
                "fechaEnvio": date,
                "isFetching": this.props.onboardDocument.get('isFetchingDocument'),
            }
        ]

        const {registrationDate , documentId} = onboardDocumentOkApi.toJS()

        const dataDocumentOkApi = [
            {
                'file': {},
                "nombreTipoComunicacion": documentType,
                "nombreGrupoComunicacion": documentType,
                "fechaAlta": registrationDate,
                "isFetching": this.props.onboardDocument.get('isFetchingDocOkApi'),
                "documentId": documentId,
            }
        ]

        return date?(
            <DocumentsTable
                data={Immutable.fromJS(data)}
                showAlias={false}
                showCurrentDocument={false}
                showDocumentationType={true}
                showAutoDates={false}
                callbackDownloadFile={this.callbackDownloadFile}
            />
        ):<DocumentsTable
            data={Immutable.fromJS(dataDocumentOkApi)}
            showAlias={false}
            showCurrentDocument={false}
            showDocumentationType={true}
            showAutoDates={false}
            downloadById={this.downloadById}
            />;
    }

    buildErrorState(errorMessage) {
        const handleRequestProducts = () => {
            this.props.getCardsCanceled();
            this.props.requestDeposits();
            this.props.getCardsInformation();
            this.props.getOnboardDocumentDate(this.getIBANFromOldestDateAccount());
        };

        const retryButton = (
            <OKButton
                id="btn_myProfileAdditionalDocumentationView_retry"
                onClick={handleRequestProducts}
            >
                <FormattedText value="profileContracts-retry" />
            </OKButton>
        );

        return (
            <OKSectionBox className="extracts_view">
                <EmptyState
                    button={retryButton}
                    primaryText={errorMessage}
                    iconType="nointernet-banking"
                />
            </OKSectionBox>
        );
    }

    callbackDownloadFile() {
        const { immProfile } = this.props;
        const isNerudaUser = immProfile.get('isNerudaUser');
        const numExpendiente = immProfile.get('numeroExpediente');
        if (isNerudaUser && numExpendiente) {
            this.props.getOnboardDocumentPdf(numExpendiente);
        } else {
            this.props.getOnboardDocumentPdf(this.getIBANFromOldestDateAccount());
        }
    }

    contentContracts() {
        const contracts = this.buildContracts();
        const errorMessage = formatText('profileContracts-errorMessage');
        let showCleanFilters;
        let filtersContent;
        let component;

        if (this.props.immAccounts.get('error')) {
            return this.buildErrorState(errorMessage);
        }

        if (this.state.interventionSelected !== -1) {
            const interventionText = this.state.interventionValue || '';
            filtersContent = (
                <div className="contracts-view__filters">
                    <LabelFilterRange
                        key="filter-intervention"
                        from={interventionText}
                        closeCallback={() => this.handleClearFilters()}
                    />
                </div>
            );
        }
        if (!contracts) {
            component = (
                <div className="contracts-view__empty">
                    <EmptyState primaryText={formatText('profileContracts-empty')} iconType="noitems-banking" />
                </div>
            );
        } else {
            component = (
                <section className="contracts-view__contracts-container">
                    <div className="contracts-view__header-container">
                        <div className="contracts-view__title-wrapper">
                            <OKBoxTitle value={formatText('profileContracts-subtitleHeader')} />
                        </div>
                        <div className="contracts-view__filter-section">
                            {showCleanFilters}
                            <OKButton modifier="task" onClick={this.handleToggleShowFilters}>
                                <i className="icon-filtrar" />
                            </OKButton>
                        </div>
                        {filtersContent}
                    </div>
                    {contracts}
                </section>
            );
        }

        return component;
    }

    filterByIntervention(interventionIndex, interventionValue) {
        this.setState({
            interventionSelected: interventionIndex,
            interventionValue: interventionValue
        });
    }

    filterData(data, interventionType) {
        const { interventionValue } = this.state;
        if (!interventionValue) {
            return data;
        }
        return data.filter(((immData) => {
            const currentInterventionType = immData.getIn(interventionType).trim();
            return currentInterventionType === interventionValue || formatText(`interventionTypes-${currentInterventionType}`) === interventionValue;
        }).bind(this));
    }

    handleClearFilters() {
        this.filterByIntervention(-1, '');
    }

    handleFilterIntervention(interventionIndex, interventionValue) {
        this.filterByIntervention(interventionIndex, interventionValue);
        this.handleToggleShowFilters();
    }

    handleToggleShowFilters() {
        this.setState({
            showFilters: !this.state.showFilters
        });
    }

    render() {
        const mappingBreadcrumb = [{
            text: formatText('breadcrumb-documentation'),
            url: '/myprofile/documentation/'
        }, {
            text: formatText('breadcrumb-contracts'),
            url: ''
        }];
        const textBox = formatText('profileContracts-textBox');
        const boxTitle = formatText('profileContracts-boxTitle');
        const contentContracts = this.contentContracts();
        const date = this.props.onboardDocument.get('date');
        const onboardDocumentOkApi = this.props.onboardDocument.get('onboardDocumentOkApi');

        const accordion = this.buildAccordion(date, onboardDocumentOkApi);
        return (
            <React.Fragment>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle('breadcrumb-contracts')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-8">
                                <FilterContracts
                                    interventionSelected={this.state.interventionSelected}
                                    interventionValue={this.state.interventionValue}
                                    interventions={this.getInterventions()}
                                    isOpen={this.state.showFilters}
                                    onClose={this.handleToggleShowFilters}
                                    onFilterByIntervention={this.handleFilterIntervention}
                                />
                                {accordion}
                                {contentContracts}
                            </div>
                            <div className="col-xs-4">
                                <div className="contracts-view__box-contract-banner-container">
                                    <ContactInfoBox boxTitle={boxTitle} icon={infoIcon} boxBody={textBox} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

MyProfileDocumentationContractsView.propTypes = {
    getCardsCanceled: PropTypes.func,
    getCardsInformation: PropTypes.func,
    getOnboardDocumentDate: PropTypes.func,
    getDocumentsOkApiById: PropTypes.func,
    getOnboardDocumentPdf: PropTypes.func,
    immAccounts: PropTypes.object,
    immCards: PropTypes.object,
    immCardsCanceled: PropTypes.object,
    immLoans: PropTypes.object,
    immSavings: PropTypes.object,
    immWallets: PropTypes.object,
    onboardDocument: PropTypes.object,
    requestDeposits: PropTypes.func,
    immProfile: PropTypes.object
};

module.exports = MyProfileDocumentationContractsView;
module.exports.MyProfileDocumentationContractsView = connect(state => ({
    immAccounts: state.accounts,
    immCards: state.cards,
    immCardsCanceled: state.cardsCanceled,
    immLoans: state.loans,
    immSavings: state.globalPosition.getIn(['savings', 'data']),
    immWallets: state.brokerWallets.get('walletList'),
    onboardDocument: state.onboardDocument,
    immProfile: state.profile
}), {
    getDocumentsOkApiById: okApiDocumentsActions.getDocumentsOkApiById,
    getCardsCanceled: cardsCanceled.getCardsCanceled,
    getCardsInformation: cardsInformation.getCardsInformation,
    getOnboardDocumentDate: onboardDocument.getOnboardDocumentDate,
    getOnboardDocumentPdf: onboardDocument.getOnboardDocumentPdf,
    requestDeposits: depositsActions.requestDeposits
})(MyProfileDocumentationContractsView);
